import { render, staticRenderFns } from "./AiAppSetting.vue?vue&type=template&id=bc76f652&scoped=true"
import script from "./AiAppSetting.vue?vue&type=script&lang=js"
export * from "./AiAppSetting.vue?vue&type=script&lang=js"
import style0 from "./AiAppSetting.vue?vue&type=style&index=0&id=bc76f652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc76f652",
  null
  
)

export default component.exports